import GuardianPage from './GuardianPage';

export default GuardianPage;
